import { OffLogo } from "@/components/shared/OffLogo";
import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Center, Group, Paper, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconAlertTriangle, IconMessage } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function EventConfirmationPage() {
  const theme = useMantineTheme();
  const navigate = useNavigate();

  return (
    <Center bg={theme.black} pb="xl" px="xl">
      <Stack align="center" gap={40}>
        <OffLogo />

        <Stack align="center" gap="md">
          <Text size="2.8rem" fw={700} ta="center" lh={1.2}>
            예약 완료!
          </Text>
          <Text size="2.8rem" fw={700} ta="center" lh={1.2} mb="lg">
            이제 만날 일만 남았어요
          </Text>
          <Text size="1.4rem" ta="center" lh={"h2"}>
            당신과 꼭 맞는 사람들과의 테이블, 곧 오프에서 만나요!
          </Text>
        </Stack>
        <Stack gap="lg" w="100%" mt="xl">
          <Paper bg={theme.colors.pink[0]} px="lg" py="sm" radius="md" c={theme.white}>
            <Group wrap="nowrap">
              <IconAlertTriangle color="black" size={28} />
              <Text size="md" fw={800} c="black">
                함께할 분들과의 소중한 약속을 지켜주세요.
              </Text>
            </Group>
          </Paper>
          <Text size="md" mx="lg" px="md">
            모임 전 월요일 자정 이후 취소/변경은 환불이 어려워요. 함께할 분들을 위해, 취소나 변경
            사항이 있으면 꼭 예약 관리를 통해서 알려주세요.
          </Text>

          <Paper bg={theme.colors.lightGreen[0]} px="lg" py="sm" radius="md" c={theme.white}>
            <Group wrap="nowrap">
              <IconMessage color="black" size={28} />
              <Text size="md" fw={800} c="black">
                예약 요청 후 1-3일내 초대 확정 문자가 발송돼요.
              </Text>
            </Group>
          </Paper>
          <Text size="md" mx="lg" px="md">
            오프는 취향, 연령, 성별을 고려해 당신과 가장 잘 어울리는 테이블을 만들어요. 최고의
            경험을 위해, 매칭이 어려울 경우, 초대는 취소되며 전액 환불돼요.
          </Text>
        </Stack>

        <Center style={{ width: "100%", marginTop: "50px" }}>
          <StyledActionButton
            onClick={() => navigate("/home")}
            width="100%"
            fontWeight={700}
            textColor={theme.colors.dark[8]}
            size="lg"
          >
            이해했어요!
          </StyledActionButton>
        </Center>
      </Stack>
    </Center>
  );
}
